import { getInvertedColor as getInvertedColorFromUtils } from '@elfsight/widget-utils';

const checkTransparent = (color: string) => {
  const regex =
    /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([01](\.\d+)?)\s*\)$/;

  const matches = color?.match(regex);

  if (matches) {
    const alpha = parseFloat(matches[4]);

    return alpha < 0.5;
  }

  return color === 'transparent';
};

export const getInvertedColor = ({
  color,
  opacity = 1
}: {
  color?: string;
  opacity?: number;
}) => {
  if (!color) return undefined;

  if (checkTransparent(color)) {
    return 'rgba(17, 17, 17, 1)';
  }

  const invertedColor = getInvertedColorFromUtils(
    color,
    ['rgb(255, 255, 255)', 'rgb(17, 17, 17)'],
    172
  );
  const matches = invertedColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);

  if (!matches) return undefined;

  const [red = 0, green = 0, blue = 0] = matches?.slice(1) || [];
  const validAlpha = Math.min(1, Math.max(0, opacity));

  return `rgba(${red}, ${green}, ${blue}, ${validAlpha})`;
};
